import React, { useState } from "react"
import { ActionPlanContext } from "../context"
import { FilterProps } from "../../../hooks/filter/typing"
import { useFilter } from "../../../hooks/filter"

const ActionPlanProvider = (props: { children: JSX.Element }) => {
    const doNotHaveAcces = true
    const [filterPayload, setFilterPayload] = React.useState<FilterProps>({ formatFilter: {} })
    const filterData = useFilter(filterPayload)
    const [actionPlanOfStores, setActionPlanOfStores] = React.useState(!!doNotHaveAcces)
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [notSelected, setNotSelected] = useState<number[]>([]);
    const [isChecked, setIsChecked] = useState(false)

    return (
        <ActionPlanContext.Provider
            value={{
                filterData,
                actionPlanOfStores,
                doNotHaveAcces,
                setActionPlanOfStores,
                setFilterPayload,
                isChecked,
                notSelected,
                selectedIds,
                setIsChecked,
                setNotSelected,
                setSelectedIds
            }}
        >
            {props.children}
        </ActionPlanContext.Provider>
    )
}

export { ActionPlanProvider }
